import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getAdditions = async ({companyCode}) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetAdditions}?isAll=true&CompanyCode=${companyCode}`
  );
  return data;
};

export const useGetAdditionsQuery = (companyCode) => {
    
  return useQuery({
    queryKey: [Api_EndPoints.GetAdditions],
    queryFn: () => getAdditions(companyCode),
    refetchOnWindowFocus: false,
  });
};
